import { Injector } from '@angular/core';
import { RoutingService } from 'src/app/core/services/routing.service';
import { ActivatedRoute } from '@angular/router';
import { Page } from 'src/app/core/routes/routes';
import { TabService } from 'src/app/core/services/tab.service';
import { StoreService } from '../../services/store.service';

export abstract class BaseComponent {
    routerService: RoutingService;
    routeService: ActivatedRoute;
    tabService: TabService;
    storeService: StoreService;

    readonly queryParams;
    readonly params;

    protected constructor(injector: Injector) {
        this.routerService = injector.get(RoutingService);
        this.routeService = injector.get(ActivatedRoute);
        this.tabService = injector.get(TabService);
        this.storeService = injector.get(StoreService);

        this.queryParams = this.routeService.snapshot.queryParams;
        this.params = this.routeService.snapshot.params;
    }

    goToPage(currentPage: Page, args?) {
        return this.routerService.goToRoute(currentPage, args);
    }

    goToPageWithQueryParam(currentPage: Page) {
        return this.routerService.goToPage(currentPage, { id: this.queryParams.id });
    }
}
